var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSketchy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 58,
    height: 58,
    rx: 16,
    fill: "#FDDB44",
    stroke: "#184985",
    strokeWidth: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#184985",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 41h16"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36 41) rotate(28)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0l-8-5v10z",
    fill: "#184985"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8-5h-16v10h16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-24-5v10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-24-4h-7v8h7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSketchy);
export default __webpack_public_path__ + "static/media/sketchy.ec26c50b4893e01b5092cd25d4c3f34d.svg";
export { ForwardRef as ReactComponent };